import { render, staticRenderFns } from "./dailyQuestionSix.vue?vue&type=template&id=6938f256&scoped=true"
import script from "./dailyQuestionSix.vue?vue&type=script&lang=js"
export * from "./dailyQuestionSix.vue?vue&type=script&lang=js"
import style0 from "./dailyQuestionSix.vue?vue&type=style&index=0&id=6938f256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6938f256",
  null
  
)

export default component.exports